import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrJsaPage } from './klmr-jsa';

@NgModule({
  declarations: [
    KlmrJsaPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrJsaPage),
  ],
})
export class KlmrJsaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-jsa/klmr-jsa.module.ts